import axios, { CancelToken } from 'axios';
import { useEffect, useMemo } from 'react';

export const useCancelToken = (): CancelToken => {
  const tokenSource = useMemo(() => axios.CancelToken.source(), []);

  useEffect(() => {
    return () => tokenSource.cancel();
  }, [tokenSource]);

  return tokenSource.token;
};
